export const GTM_ID = "GTM-KL8PMMW"

export const addToDataLayer = (data) => {
  if (typeof window === "undefined") return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}
